import { graphql } from "gql.tada";

const NodeUpdateManyMut = graphql(`
  mutation updateNodes($input: UpdateNodesInput!) {
    updateNodes(input: $input) {
      status
      message
    }
  }
`);

const NodeCreateManyMut = graphql(`
  mutation createNodes($input: CreateNodesInput!) {
    createNodes(input: $input) {
      status
      message
    }
  }
`);

const NodeDeleteManyMut = graphql(`
  mutation deleteNodes($input: DeleteNodesInput!) {
    deleteNodes(input: $input) {
      status
      message
    }
  }
`);

const ProcessNodesMut = graphql(`
  mutation processNodes($input: ProcessNodesInput!) {
    processNodes(input: $input) {
      message
      status
    }
  }
`);

// used also for moving the node (and its children) from one position to another
const NodeUpdateMut = graphql(`
  mutation updateProjectNode($input: UpdateProjectNodeInput) {
    updateProjectNode(input: $input) {
      id
      title
      kind
      configurations
      referencePosition
      parentId
      nodes
      systemPath
      localPath
    }
  }
`);

const NodeDeleteMut = graphql(`
  mutation deleteProjectNode($input: DeleteProjectNodeInput!) {
    deleteProjectNode(input: $input) {
      id
      title
      kind
      referencePosition
      parentId
      nodes
      systemPath
      localPath
    }
  }
`);

export {
  NodeUpdateMut,
  NodeDeleteMut,
  ProcessNodesMut,
  NodeUpdateManyMut,
  NodeCreateManyMut,
  NodeDeleteManyMut,
};
